import React, { Fragment, useEffect, useRef, useState } from 'react'
import TextField from 'components/TextField/TextField'
import { formatNumber } from 'utils/number'
import Web3 from 'web3'
import { floorNumber } from 'utils/number'
import { compareBigDecimal } from 'utils/number'
import { MAX_DECIMAL_FORMAT } from 'constants/common'
import { REGEX_NUMBER_DECIMAL } from 'constants/common'
import { BNB_TRANSACTION_FEE } from 'constants/common'
import bigDecimal from 'js-big-decimal'
import { useGetManagementContractQuery } from 'hooks/useGetManagementContractQuery'
import { useGetPaymentContractQuery } from 'hooks/useGetPaymentContractQuery'
import { getPaymentContract } from 'utils/contract'
import { useGetUserInfoQuery } from 'hooks/useGetUserInfoQuery'
import { useContributeMutation } from 'hooks/useContributeMutation'
import { useSelector } from 'react-redux'

const MIN_BNB = 0.02

export default function ContributeForm() {
	const { data: paymentContract } = useGetPaymentContractQuery()

	const { birBurningRate = 0, bicRateForCoreTeam = 0, currentPrice = 0, bnbThreshold = 0 } =
		paymentContract || {}

	const { data: userInfo } = useGetUserInfoQuery()

	const { isWhiteList, isCoreTeam, birBalance, bnbBalance } = userInfo || {}
	const {
		data: { inRound },
	} = useGetManagementContractQuery()
	const [bnbSpent, setBnbAmount] = useState('')
	const [birAmount, setBirAmount] = useState('')

	const defaultPaymentInfo = {
		bicForBirBurning: 0,
		totalBicReceived: 0,
		birBurn: 0,
		bicRewardsCoreTeam: 0,
		bicForBnbSpending: 0,
		bicForBnbThreshold: 0,
		bgtReceive: 0,
	}

	const [paymentInfo, setPaymentInfo] = useState(defaultPaymentInfo)
	const [canSubmitContribute, setCanSubmitContribute] = useState(false)
	const [errorMessage, setErrorMessage] = useState({
		bnb: '',
		bir: '',
		bic: '',
	})

	const { mutate: contribute } = useContributeMutation()

	const formContribute = useRef(null)

	const contributeInfo = useSelector((state) => state.ContributeInfoReducer)

	const percentAirdropBIR = birBurningRate * 100
	const percentAirdropCoreTeam = bicRateForCoreTeam * 100

	const maxBNB = bnbBalance - BNB_TRANSACTION_FEE

	// total bic
	const totalBICReceived = paymentInfo.totalBicReceived

	const handleClearPrice = () => {
		setPaymentInfo(defaultPaymentInfo)
	}

	const getExpectResultContribute = async (bnbSpent = 0, birAmount = 0) => {
		try {
			const birMax = bigDecimal.divide(bnbSpent, currentPrice, 18)
			const birBurn = birAmount >= birMax ? birMax : birAmount

			if (!bnbSpent) {
				handleClearPrice()
				return
			}

			const contracts = getPaymentContract()

			const results = await contracts.methods
				.getPaymentInfo(
					Web3.utils.toWei(String(bnbSpent)),
					Web3.utils.toWei(String(floorNumber(birBurn) || 0)),
				)
				.call()

			const [
				,
				bicForBnbSpending,
				bicForBirBurning,
				bgtReceive,
				,
				,
				bicForBnbThreshold,
				bicForCoreTeam,
			] = Object.values(results)

			const bicRewardsCoreTeam = isCoreTeam
				? floorNumber(Web3.utils.fromWei(bicForCoreTeam))
				: 0

			setPaymentInfo({
				bicForBirBurning: floorNumber(Web3.utils.fromWei(bicForBirBurning)),
				bicForBnbSpending: floorNumber(Web3.utils.fromWei(bicForBnbSpending)),
				totalBicReceived:
					floorNumber(Web3.utils.fromWei(bicForBnbSpending)) +
					floorNumber(Web3.utils.fromWei(bicForBirBurning)) +
					bicRewardsCoreTeam +
					floorNumber(Web3.utils.fromWei(bicForBnbThreshold)),
				bicRewardsCoreTeam,
				birBurn: floorNumber(birBurn),
				bicForBnbThreshold: floorNumber(Web3.utils.fromWei(bicForBnbThreshold)),
				bgtReceive: floorNumber(Web3.utils.fromWei(bgtReceive)),
			})
		} catch (error) {
			//console.log(error)
		}
	}

	useEffect(async () => {
		getExpectResultContribute(Number(bnbSpent), Number(birAmount))
	}, [bnbSpent, birAmount])

	const canContribute = isWhiteList && inRound

	useEffect(() => {
		//all in bir
		setBirAmount(floorNumber(birBalance, 3))
	}, [birBalance])

	const handleChangeBNBAmount = (event) => {
		if (!event.target.value) {
			setBnbAmount('')
			return
		}
		if (!REGEX_NUMBER_DECIMAL.test(event.target.value)) {
			return
		}
		const numberSplit = event.target.value.split('.')
		if (numberSplit[0]?.length > 7) {
			return
		}
		if (numberSplit[1]?.length > MAX_DECIMAL_FORMAT) {
			return
		}
		setBnbAmount(event.target.value)
	}

	const handleChangeBirAmount = (event) => {
		if (!event.target.value) {
			setBirAmount('')
			return
		}
		if (!REGEX_NUMBER_DECIMAL.test(event.target.value)) {
			return
		}
		const numberSplit = event.target.value.split('.')
		if (numberSplit[0]?.length > 7) {
			return
		}
		if (numberSplit[1]?.length > MAX_DECIMAL_FORMAT) {
			return
		}
		setBirAmount(event.target.value)
	}

	const titleContributeBNB = (
		<>
			<div>Số lượng BNB muốn đổi</div>
			<div className='text-green-40'>Đang có: {formatNumber(floorNumber(bnbBalance))}</div>
		</>
	)

	const titleContributeBir = (
		<>
			<div>Số lượng BIR muốn Đốt</div>
			<div className='text-green-40'>Đang có: {formatNumber(floorNumber(birBalance))}</div>
		</>
	)

	const placeholderBir = 'Nhập số lượng BIR'

	useEffect(() => {
		//error flow step by step
		if (compareBigDecimal(MIN_BNB, bnbBalance) === 1) {
			setErrorMessage({
				...errorMessage,
				bic: '',
				bir: '',
				bnb: `Số BNB tối thiểu trong ví là ${MIN_BNB} BNB`,
			})
			setCanSubmitContribute(false)
			return
		}
		// Bir đốt lón hơn Bir đang có
		if (compareBigDecimal(birAmount, birBalance) === 1) {
			setErrorMessage({
				...errorMessage,
				bic: '',
				bnb: '',
				bir: 'Số BIR đốt lớn hơn số dư bạn đang có',
			})
			setCanSubmitContribute(false)
			return
		}
		//BNB không đủ
		if (!Number(bnbSpent)) {
			setCanSubmitContribute(false)
			setErrorMessage({})
			return
		}

		// BNB quy đổi lớn hơn số BNB đang có
		if (compareBigDecimal(bnbSpent, bnbBalance) === 1) {
			setErrorMessage({
				...errorMessage,
				bic: '',
				bir: '',
				bnb: 'Số BNB quy đổi lớn hơn số dư bạn đang có',
			})
			setCanSubmitContribute(false)
			return
		}

		if (compareBigDecimal(bnbSpent, maxBNB) === 1) {
			setErrorMessage({
				...errorMessage,
				bic: '',
				bir: '',
				bnb: `Số BNB tối đa có thể giao dịch là ${floorNumber(
					maxBNB,
				)} vì cần phải trừ phí giao dịch.`,
			})
			setCanSubmitContribute(false)
			return
		}

		//không có quyền đóng góp
		if (!canContribute) {
			setCanSubmitContribute(false)
			setErrorMessage({})
			return
		}
		setErrorMessage({})
		setCanSubmitContribute(true)
	}, [bnbBalance, bnbSpent, birBalance, birAmount, canContribute, maxBNB, contributeInfo])

	return (
		<div className='bein-card bein-form mb-4' style={{ height: 'auto' }}>
			<div className='bein-card-header'>
				<h3>Đóng góp cho dự án Beincom</h3>
			</div>
			<div className='bein-card-body'>
				<div className='row form-price-top p-2'>
					<div className='col-12 col-md-6'>
						<TextField
							className='gtm-bnb-amount'
							ref={formContribute}
							error={errorMessage.bnb}
							title={titleContributeBNB}
							onChange={handleChangeBNBAmount}
							value={bnbSpent}
							placeholder={'Nhập số lượng BNB'}
							maxNumber={10}
							onSubmit={() => {
								setBnbAmount(floorNumber(maxBNB))
							}}
						/>
					</div>
					<div className='col-12 col-md-6 mt-4 mt-md-0'>
						<TextField
							className='gtm-bir-amount'
							error={errorMessage.bir}
							title={titleContributeBir}
							onChange={handleChangeBirAmount}
							value={birAmount}
							onSubmit={() => {
								setBirAmount(floorNumber(birBalance, 3))
							}}
							placeholder={placeholderBir}
							maxNumber={10}
						/>
					</div>
					<div className='col-12 col-md-6 mt-4'>
						<div className='heading-200 d-flex justify-content-between'>
							<div>BGT nhận thưởng</div>
							<div className='text-primary-40'>
								{formatNumber(paymentInfo.bgtReceive)} BGT
							</div>
						</div>
						<div className='heading-200 d-flex justify-content-between'>
							<div>BIC đổi được</div>
							<div className='text-primary-40'>
								{formatNumber(paymentInfo.bicForBnbSpending)} BIC
							</div>
						</div>
						<div className='heading-200 d-flex justify-content-between'>
							<div>
								BIC thưởng core team
								<span className='text-green-40'>
									{' '}
									(+{percentAirdropCoreTeam}%)
								</span>
							</div>
							<div className='text-green-40'>
								{formatNumber(paymentInfo.bicRewardsCoreTeam)} BIC
							</div>
						</div>
					</div>
					<div className='col-12 col-md-6 mt-md-4'>
						<div className='heading-200 d-flex justify-content-between'>
							<div>BIR dự tính được đốt</div>
							<div className='text-red-5'>
								{formatNumber(paymentInfo.birBurn)} BIR
							</div>
						</div>
						<div className='heading-200 d-flex justify-content-between'>
							<div>
								BIC thưởng từ đốt BIR
								<span className='text-green-40'>
									{' '}
									(+{Math.round(percentAirdropBIR)}%)
								</span>
							</div>
							<div className='text-green-40'>
								{formatNumber(paymentInfo.bicForBirBurning)} BIC
							</div>
						</div>
						<div className='heading-200 d-flex justify-content-between'>
							<div>
								BIC thưởng đóng góp lớn{' '}
								<span className='text-green-40'>
									(&gt;= {bnbThreshold} BNB)
								</span>
							</div>
							<div className='text-green-40'>
								{formatNumber(paymentInfo.bicForBnbThreshold)} BIC
							</div>
						</div>
					</div>
					<div className='col-12 mt-4'>
						<TextField
							value={formatNumber(totalBICReceived)}
							title={'Tổng BIC nhận được dự kiến'}
							className='text-primary-40'
							disabled={true}
							error={errorMessage.bic}
							type='text'
						/>
					</div>
				</div>
				<div className='bein-card-button text-center d-block'>
					<div className='form-button heading-200'>
						<button
							className={`gtm-btn-submit btn-submit ${
								!canSubmitContribute ? '' : 'btn-submit-on'
							}`}
							disabled={!canSubmitContribute}
							color='danger'
							onClick={() => {
								contribute({
									bnbSpent,
									birBurn: paymentInfo.birBurn || 0,
								})
								handleClearPrice()
								setBnbAmount(0)
								setBirAmount(0)
							}}
						>
							Đóng góp
						</button>
					</div>
					{bnbSpent > 0 ? (
						<p className='heading-75 text-error'>
							Hãy kiểm tra thông tin một lần nữa, một khi đã đóng góp thì
							<span style={{ fontWeight: 'bold' }}> không sửa được </span> vì
							thông tin đã lưu trên blockchain
						</p>
					) : (
						''
					)}
				</div>
			</div>
			{isWhiteList || isCoreTeam ? (
				<div
					className='form-floating-button'
					onClick={() => {
						formContribute.current?.scrollIntoView({
							behavior: 'smooth',
							block: 'center',
						})
						formContribute.current?.focus()
					}}
				>
					<div className='form-floating-button-content'>
						<div className='floating-button-tooltip d-none d-xl-block'>
							Đi đến phần đóng góp
						</div>
						<div className='floating-button-rectangle d-none d-xl-block'></div>
						<svg
							width={28}
							height={28}
							viewBox='0 0 28 28'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								d='M21.264 16.94L16.917 20.4167H11.0837V19.25H15.8262C15.9317 19.2499 16.0352 19.2213 16.1257 19.167C16.2162 19.1128 16.2903 19.035 16.3401 18.942C16.3899 18.849 16.4136 18.7442 16.4085 18.6388C16.4035 18.5334 16.3699 18.4313 16.3115 18.3435L15.2755 16.7895C15.063 16.4696 14.7746 16.2073 14.4361 16.0259C14.0975 15.8445 13.7194 15.7497 13.3353 15.75H4.08366C3.77424 15.75 3.47749 15.8729 3.2587 16.0917C3.03991 16.3105 2.91699 16.6072 2.91699 16.9167V23.9167C2.91699 24.5355 3.16282 25.129 3.60041 25.5666C4.03799 26.0042 4.63149 26.25 5.25033 26.25H16.4958C16.9947 26.2501 17.4878 26.1436 17.9422 25.9375C18.3965 25.7315 18.8016 25.4307 19.1302 25.0553L26.2503 16.9167L24.5563 16.352C24.0021 16.1673 23.4104 16.1243 22.8353 16.227C22.2602 16.3297 21.72 16.5748 21.264 16.94Z'
								fill='#7843DD'
							/>
							<g clipPath='url(#clip0_885_21707)'>
								<path
									d='M17.4202 15.7467C21.0205 15.7467 23.9391 12.8461 23.9391 9.2681C23.9391 5.6901 21.0205 2.78955 17.4202 2.78955C13.82 2.78955 10.9014 5.6901 10.9014 9.2681C10.9014 12.8461 13.82 15.7467 17.4202 15.7467Z'
									fill='white'
								/>
								<path
									d='M11.9414 9.28433C11.9851 9.58588 12.0514 9.88388 12.1397 10.1759L15.4024 9.227L12.1886 10.3385C12.2173 10.4263 12.2483 10.5141 12.2806 10.5989L17.6721 8.78531L20.057 14.46C20.4838 14.3421 20.8969 14.1807 21.2895 13.9786L18.4274 7.13379L11.9414 9.28433ZM20.1525 14.2763L17.7312 8.5238L16.8229 8.71628L17.8978 8.24182L20.2266 14.1874L20.1525 14.2763Z'
									fill='white'
								/>
								<path
									d='M12.2783 10.5953C12.8441 12.0771 13.9576 13.2964 15.398 14.0116C16.8384 14.7268 18.5005 14.8856 20.0547 14.4565L17.6698 8.78174L12.2783 10.5953Z'
									fill='#7843DD'
								/>
								<path
									d='M16.8232 8.71615L17.7315 8.52368L20.1528 14.2762L20.2287 14.1873L17.8981 8.2417L16.8232 8.71615Z'
									fill='#7843DD'
								/>
								<path
									d='M12.1396 10.1758C12.1558 10.2296 12.1707 10.2834 12.1886 10.3366L15.4024 9.2251L12.1396 10.1758Z'
									fill='#7843DD'
								/>
								<mask id='path-7-inside-1_885_21707' fill='white'>
									<path d='M17.4173 2.648C16.0814 2.64708 14.7752 3.0344 13.6641 3.76096C12.5529 4.48751 11.6867 5.52066 11.1751 6.72966C10.6634 7.93867 10.5293 9.2692 10.7897 10.5529C11.0501 11.8366 11.6933 13.0158 12.6379 13.9413C13.5825 14.8667 14.7861 15.4969 16.0963 15.752C17.4066 16.0071 18.7647 15.8757 19.9987 15.3744C21.2327 14.8731 22.2872 14.0245 23.0288 12.9359C23.7704 11.8473 24.1658 10.5676 24.1648 9.25877C24.1684 8.38965 23.9963 7.52845 23.6584 6.72482C23.3206 5.9212 22.8237 5.19105 22.1964 4.57649C21.5692 3.96193 20.8239 3.47511 20.0036 3.14412C19.1834 2.81314 18.3044 2.64452 17.4173 2.648V2.648ZM13.6667 4.03334C13.4119 4.21494 13.1708 4.41437 12.9454 4.63006C13.1707 4.41425 13.4118 4.21481 13.6667 4.03334V4.03334ZM12.9424 4.63299C12.7627 4.80443 12.593 4.98569 12.4342 5.17589C12.593 4.98569 12.7627 4.80443 12.9424 4.63299V4.63299ZM20.2309 14.8785C20.1903 14.8984 20.1491 14.9171 20.1115 14.937L20.0781 14.9522L19.964 15.0019L19.9204 15.0207L19.8124 15.0645L19.7604 15.085L19.6565 15.1236L19.5968 15.1453L19.4965 15.1798L19.432 15.2009L19.3346 15.2319L19.2654 15.2529L19.1704 15.2798L19.0964 15.3003L19.0038 15.3243L18.9262 15.343L18.8349 15.3641L18.753 15.3816L18.6641 15.3998L18.5787 15.4156L18.4909 15.4308L18.4019 15.4448L18.3165 15.4571C18.2855 15.4618 18.2568 15.4653 18.2228 15.4694L18.1398 15.4793L18.0413 15.4887L17.9618 15.4963L17.8562 15.5039L17.7821 15.5086L17.6627 15.5138H17.6C17.5403 15.5138 17.4806 15.5138 17.4179 15.5138C15.7238 15.5131 14.0995 14.8532 12.9019 13.6794C11.7043 12.5055 11.0316 10.9138 11.0316 9.25409C11.0316 9.17803 11.0316 9.10257 11.0363 9.0271C11.0363 9.00721 11.0363 8.98732 11.0363 8.9686C11.0393 8.90132 11.0435 8.83463 11.0483 8.76852C11.0483 8.75916 11.0483 8.75038 11.0483 8.74102C11.0543 8.66731 11.062 8.59418 11.071 8.52105C11.071 8.50175 11.0758 8.48244 11.0781 8.46255C11.0859 8.40405 11.0949 8.34087 11.1044 8.28061C11.1044 8.26598 11.1086 8.25194 11.111 8.23732C11.1229 8.16594 11.1361 8.09516 11.1504 8.02495C11.154 8.00682 11.1582 7.98868 11.1623 7.96996C11.1743 7.91146 11.1874 7.85647 11.2012 7.79972L11.2137 7.74765C11.231 7.6792 11.2495 7.61076 11.2692 7.54289C11.274 7.52593 11.2794 7.50955 11.2842 7.49258C11.3003 7.43817 11.3176 7.38435 11.3355 7.33053C11.3415 7.31122 11.3481 7.29133 11.3546 7.27203C11.3767 7.20651 11.4 7.14098 11.4251 7.07604C11.4305 7.06142 11.4364 7.04679 11.4424 7.03158C11.4627 6.97893 11.4836 6.92686 11.5057 6.87538L11.532 6.81278C11.5594 6.75019 11.5869 6.68759 11.6162 6.62616C11.6215 6.61446 11.6275 6.60335 11.6329 6.59165C11.6586 6.53899 11.6842 6.48751 11.7111 6.43544C11.7219 6.41438 11.7332 6.39332 11.7445 6.37226C11.7714 6.32136 11.7983 6.27164 11.8269 6.22191C11.8353 6.20729 11.8431 6.19207 11.852 6.17745C11.8837 6.12246 11.9165 6.06805 11.95 6.01423L11.99 5.95046C12.0168 5.90775 12.0449 5.86563 12.073 5.82351L12.107 5.77261C12.144 5.71879 12.1816 5.66555 12.2199 5.61349L12.2706 5.5544C12.2993 5.51696 12.3303 5.47952 12.3572 5.44266L12.402 5.38416C12.4426 5.33443 12.4838 5.28529 12.525 5.23673L12.5769 5.17823C12.6068 5.1443 12.6367 5.11037 12.6677 5.07702C12.6856 5.05713 12.7035 5.03724 12.722 5.01852C12.7656 4.9723 12.8098 4.92667 12.8552 4.88162C12.8731 4.86349 12.8916 4.84594 12.9095 4.82838C12.9418 4.79679 12.9746 4.76579 13.0075 4.73478L13.0672 4.67628C13.1138 4.63357 13.1603 4.59204 13.2081 4.5505C13.2816 4.48732 13.3562 4.42647 13.4326 4.3668L13.4726 4.33638C13.5323 4.28958 13.5956 4.24336 13.6583 4.1989L13.7181 4.15444C13.7778 4.11349 13.8375 4.0737 13.8972 4.03451C13.9175 4.02164 13.9372 4.00818 13.9569 3.9959C14.0357 3.94617 14.1151 3.89761 14.1958 3.85081C14.2782 3.80401 14.3618 3.75877 14.4466 3.71509L14.5242 3.68232C14.5839 3.65132 14.6484 3.62382 14.7111 3.59282L14.7971 3.5542C14.8568 3.52671 14.9201 3.50097 14.9822 3.47581L15.0652 3.44422C15.1536 3.4097 15.2443 3.37694 15.3321 3.34652C15.2608 3.37538 15.1918 3.40405 15.1249 3.43252H15.1201C15.0968 3.44246 15.0741 3.45358 15.0508 3.46469H15.0467L15.0222 3.47581C14.9893 3.49102 14.9559 3.50623 14.9237 3.52203L14.9135 3.52612L14.8263 3.57468L14.7248 3.62382L14.7099 3.63143C14.6776 3.64839 14.6466 3.66653 14.6149 3.68408L14.5325 3.7303L14.5122 3.74141L14.4143 3.79991L14.345 3.84204L14.3194 3.85783C14.2859 3.87889 14.2531 3.90112 14.2202 3.92277H14.2238L14.2011 3.93739L14.1611 3.96372C14.1187 3.99239 14.0775 4.02222 14.0363 4.05089L14.0077 4.07078L13.9838 4.08774C13.9402 4.11934 13.8978 4.1521 13.8548 4.18486L13.8226 4.20943L13.8124 4.21762C13.7676 4.25272 13.7234 4.28841 13.6792 4.32468L13.6458 4.35218C13.5998 4.39079 13.555 4.4294 13.5103 4.46918L13.484 4.49258C13.4374 4.53412 13.392 4.57682 13.3472 4.61953L13.3275 4.63825C13.281 4.6833 13.235 4.72835 13.1902 4.77456L13.1759 4.78919C13.1301 4.83716 13.0847 4.88572 13.0397 4.93486C13.0368 4.93845 13.0336 4.94178 13.0302 4.9448C12.9848 4.9957 12.9394 5.04718 12.8952 5.09925L12.8898 5.10569C12.8451 5.15892 12.8009 5.21333 12.7573 5.26832C12.7131 5.32682 12.6701 5.38123 12.6277 5.43856C12.1334 6.34835 11.8756 7.36346 11.8771 8.3941C11.8771 8.54679 11.8831 8.69832 11.8938 8.84808L18.6479 6.60744L21.6461 13.7798L21.7178 13.736L21.7566 13.7096L21.7942 13.6839L21.8336 13.6564L21.8766 13.6254L21.9077 13.6026L21.916 13.5967L21.8916 13.6149L21.9357 13.5815L21.9471 13.5733L21.9656 13.5593L21.9757 13.5517L21.9931 13.5376L22.0528 13.4908L22.0707 13.4762L22.082 13.4674L22.1035 13.4499L22.1238 13.4329L22.1638 13.399L22.171 13.3937L22.1853 13.3814L22.2104 13.3598L22.2576 13.3182L22.2713 13.3054L22.2791 13.2989L22.2928 13.2861C22.3197 13.2615 22.3466 13.2363 22.374 13.21C22.3179 13.2771 22.2602 13.3434 22.2009 13.4089C22.1642 13.4479 22.1272 13.4869 22.0898 13.5259C22.0522 13.5657 22.0146 13.6043 21.9757 13.6429C21.842 13.7769 21.7017 13.9039 21.5578 14.0255C21.1598 14.3581 20.7216 14.6414 20.253 14.8691L20.2309 14.8785ZM23.0727 12.5595C23.1523 12.4335 23.2271 12.3048 23.2972 12.1734C23.2267 12.3052 23.1519 12.4339 23.0727 12.5595Z' />
								</mask>
								<path
									d='M17.4173 2.648C16.0814 2.64708 14.7752 3.0344 13.6641 3.76096C12.5529 4.48751 11.6867 5.52066 11.1751 6.72966C10.6634 7.93867 10.5293 9.2692 10.7897 10.5529C11.0501 11.8366 11.6933 13.0158 12.6379 13.9413C13.5825 14.8667 14.7861 15.4969 16.0963 15.752C17.4066 16.0071 18.7647 15.8757 19.9987 15.3744C21.2327 14.8731 22.2872 14.0245 23.0288 12.9359C23.7704 11.8473 24.1658 10.5676 24.1648 9.25877C24.1684 8.38965 23.9963 7.52845 23.6584 6.72482C23.3206 5.9212 22.8237 5.19105 22.1964 4.57649C21.5692 3.96193 20.8239 3.47511 20.0036 3.14412C19.1834 2.81314 18.3044 2.64452 17.4173 2.648V2.648ZM13.6667 4.03334C13.4119 4.21494 13.1708 4.41437 12.9454 4.63006C13.1707 4.41425 13.4118 4.21481 13.6667 4.03334V4.03334ZM12.9424 4.63299C12.7627 4.80443 12.593 4.98569 12.4342 5.17589C12.593 4.98569 12.7627 4.80443 12.9424 4.63299V4.63299ZM20.2309 14.8785C20.1903 14.8984 20.1491 14.9171 20.1115 14.937L20.0781 14.9522L19.964 15.0019L19.9204 15.0207L19.8124 15.0645L19.7604 15.085L19.6565 15.1236L19.5968 15.1453L19.4965 15.1798L19.432 15.2009L19.3346 15.2319L19.2654 15.2529L19.1704 15.2798L19.0964 15.3003L19.0038 15.3243L18.9262 15.343L18.8349 15.3641L18.753 15.3816L18.6641 15.3998L18.5787 15.4156L18.4909 15.4308L18.4019 15.4448L18.3165 15.4571C18.2855 15.4618 18.2568 15.4653 18.2228 15.4694L18.1398 15.4793L18.0413 15.4887L17.9618 15.4963L17.8562 15.5039L17.7821 15.5086L17.6627 15.5138H17.6C17.5403 15.5138 17.4806 15.5138 17.4179 15.5138C15.7238 15.5131 14.0995 14.8532 12.9019 13.6794C11.7043 12.5055 11.0316 10.9138 11.0316 9.25409C11.0316 9.17803 11.0316 9.10257 11.0363 9.0271C11.0363 9.00721 11.0363 8.98732 11.0363 8.9686C11.0393 8.90132 11.0435 8.83463 11.0483 8.76852C11.0483 8.75916 11.0483 8.75038 11.0483 8.74102C11.0543 8.66731 11.062 8.59418 11.071 8.52105C11.071 8.50175 11.0758 8.48244 11.0781 8.46255C11.0859 8.40405 11.0949 8.34087 11.1044 8.28061C11.1044 8.26598 11.1086 8.25194 11.111 8.23732C11.1229 8.16594 11.1361 8.09516 11.1504 8.02495C11.154 8.00682 11.1582 7.98868 11.1623 7.96996C11.1743 7.91146 11.1874 7.85647 11.2012 7.79972L11.2137 7.74765C11.231 7.6792 11.2495 7.61076 11.2692 7.54289C11.274 7.52593 11.2794 7.50955 11.2842 7.49258C11.3003 7.43817 11.3176 7.38435 11.3355 7.33053C11.3415 7.31122 11.3481 7.29133 11.3546 7.27203C11.3767 7.20651 11.4 7.14098 11.4251 7.07604C11.4305 7.06142 11.4364 7.04679 11.4424 7.03158C11.4627 6.97893 11.4836 6.92686 11.5057 6.87538L11.532 6.81278C11.5594 6.75019 11.5869 6.68759 11.6162 6.62616C11.6215 6.61446 11.6275 6.60335 11.6329 6.59165C11.6586 6.53899 11.6842 6.48751 11.7111 6.43544C11.7219 6.41438 11.7332 6.39332 11.7445 6.37226C11.7714 6.32136 11.7983 6.27164 11.8269 6.22191C11.8353 6.20729 11.8431 6.19207 11.852 6.17745C11.8837 6.12246 11.9165 6.06805 11.95 6.01423L11.99 5.95046C12.0168 5.90775 12.0449 5.86563 12.073 5.82351L12.107 5.77261C12.144 5.71879 12.1816 5.66555 12.2199 5.61349L12.2706 5.5544C12.2993 5.51696 12.3303 5.47952 12.3572 5.44266L12.402 5.38416C12.4426 5.33443 12.4838 5.28529 12.525 5.23673L12.5769 5.17823C12.6068 5.1443 12.6367 5.11037 12.6677 5.07702C12.6856 5.05713 12.7035 5.03724 12.722 5.01852C12.7656 4.9723 12.8098 4.92667 12.8552 4.88162C12.8731 4.86349 12.8916 4.84594 12.9095 4.82838C12.9418 4.79679 12.9746 4.76579 13.0075 4.73478L13.0672 4.67628C13.1138 4.63357 13.1603 4.59204 13.2081 4.5505C13.2816 4.48732 13.3562 4.42647 13.4326 4.3668L13.4726 4.33638C13.5323 4.28958 13.5956 4.24336 13.6583 4.1989L13.7181 4.15444C13.7778 4.11349 13.8375 4.0737 13.8972 4.03451C13.9175 4.02164 13.9372 4.00818 13.9569 3.9959C14.0357 3.94617 14.1151 3.89761 14.1958 3.85081C14.2782 3.80401 14.3618 3.75877 14.4466 3.71509L14.5242 3.68232C14.5839 3.65132 14.6484 3.62382 14.7111 3.59282L14.7971 3.5542C14.8568 3.52671 14.9201 3.50097 14.9822 3.47581L15.0652 3.44422C15.1536 3.4097 15.2443 3.37694 15.3321 3.34652C15.2608 3.37538 15.1918 3.40405 15.1249 3.43252H15.1201C15.0968 3.44246 15.0741 3.45358 15.0508 3.46469H15.0467L15.0222 3.47581C14.9893 3.49102 14.9559 3.50623 14.9237 3.52203L14.9135 3.52612L14.8263 3.57468L14.7248 3.62382L14.7099 3.63143C14.6776 3.64839 14.6466 3.66653 14.6149 3.68408L14.5325 3.7303L14.5122 3.74141L14.4143 3.79991L14.345 3.84204L14.3194 3.85783C14.2859 3.87889 14.2531 3.90112 14.2202 3.92277H14.2238L14.2011 3.93739L14.1611 3.96372C14.1187 3.99239 14.0775 4.02222 14.0363 4.05089L14.0077 4.07078L13.9838 4.08774C13.9402 4.11934 13.8978 4.1521 13.8548 4.18486L13.8226 4.20943L13.8124 4.21762C13.7676 4.25272 13.7234 4.28841 13.6792 4.32468L13.6458 4.35218C13.5998 4.39079 13.555 4.4294 13.5103 4.46918L13.484 4.49258C13.4374 4.53412 13.392 4.57682 13.3472 4.61953L13.3275 4.63825C13.281 4.6833 13.235 4.72835 13.1902 4.77456L13.1759 4.78919C13.1301 4.83716 13.0847 4.88572 13.0397 4.93486C13.0368 4.93845 13.0336 4.94178 13.0302 4.9448C12.9848 4.9957 12.9394 5.04718 12.8952 5.09925L12.8898 5.10569C12.8451 5.15892 12.8009 5.21333 12.7573 5.26832C12.7131 5.32682 12.6701 5.38123 12.6277 5.43856C12.1334 6.34835 11.8756 7.36346 11.8771 8.3941C11.8771 8.54679 11.8831 8.69832 11.8938 8.84808L18.6479 6.60744L21.6461 13.7798L21.7178 13.736L21.7566 13.7096L21.7942 13.6839L21.8336 13.6564L21.8766 13.6254L21.9077 13.6026L21.916 13.5967L21.8916 13.6149L21.9357 13.5815L21.9471 13.5733L21.9656 13.5593L21.9757 13.5517L21.9931 13.5376L22.0528 13.4908L22.0707 13.4762L22.082 13.4674L22.1035 13.4499L22.1238 13.4329L22.1638 13.399L22.171 13.3937L22.1853 13.3814L22.2104 13.3598L22.2576 13.3182L22.2713 13.3054L22.2791 13.2989L22.2928 13.2861C22.3197 13.2615 22.3466 13.2363 22.374 13.21C22.3179 13.2771 22.2602 13.3434 22.2009 13.4089C22.1642 13.4479 22.1272 13.4869 22.0898 13.5259C22.0522 13.5657 22.0146 13.6043 21.9757 13.6429C21.842 13.7769 21.7017 13.9039 21.5578 14.0255C21.1598 14.3581 20.7216 14.6414 20.253 14.8691L20.2309 14.8785ZM23.0727 12.5595C23.1523 12.4335 23.2271 12.3048 23.2972 12.1734C23.2267 12.3052 23.1519 12.4339 23.0727 12.5595Z'
									fill='#7843DD'
									stroke='#7843DD'
									strokeWidth={2}
									mask='url(#path-7-inside-1_885_21707)'
								/>
							</g>
							<defs>
								<clipPath id='clip0_885_21707'>
									<rect
										width='16.9167'
										height='15.75'
										fill='white'
										transform='translate(9.33301 1.1665)'
									/>
								</clipPath>
							</defs>
						</svg>
					</div>
				</div>
			) : (
				''
			)}
		</div>
	)
}
